import { STOREMODULE_ENDPOINT_MAP, STOREMODULE_ENDPOINTMODULE_MAP } from '@/constants'

import http from '@/$plugins/http'

import base from '../base'
import IS from '../base/is'
import CHANGE_REQUESTS from '../base/change-requests'
import SEARCH from '../base/entity-search'
import MAINENTITY from '../base/entity-main'

export default {
  namespaced: true,
  state: base.createState(IS.state, CHANGE_REQUESTS.state, SEARCH.state, MAINENTITY.state, { /* define custom state-properties */ }),
  getters: base.createGetters(IS.getters, CHANGE_REQUESTS.getters, SEARCH.getters, MAINENTITY.getters, { /* define custom getters */ }),
  mutations: base.createMutations(IS.mutations, CHANGE_REQUESTS.mutations, SEARCH.mutations, MAINENTITY.mutations, { /* define custom mutations */ }),
  actions: base.createEntityActions(STOREMODULE_ENDPOINTMODULE_MAP.order, STOREMODULE_ENDPOINT_MAP.orderreturns, IS.actions, CHANGE_REQUESTS.actions, SEARCH.actions, MAINENTITY.actions, {
    setOrderReturnState (serverModuleName = '', serverEntityName = '', entityKey = '') {
      const isKey = `${serverEntityName}/setOrderReturnState`

      return function ({ state, getters, commit, dispatch, rootGetters }, { orderReturnId, configuration }) {
        commit('setSending', { key: isKey, sending: true })

        return new Promise(resolve => {
          http({
            method: 'put',
            url: `/${serverModuleName}/api/${serverEntityName}/updatestate/${orderReturnId}`,
            data: configuration
          })
            .then(response => {
              resolve(response.data)
            })
            .catch(error => {
              console.log(error.response.data)
              resolve(error.response.data)
            })
            .finally(() => {
              commit('setLoading', { key: isKey, loading: false })
            })
        })
      }
    },
    getCreditNote (serverModuleName = '', serverEntityName = '', entityKey = '') {
      const isKey = `${serverEntityName}/getCreditNote`
      return function ({ state, getters, commit, dispatch, rootGetters }, { orderReturnId, configuration }) {
        commit('setSending', { key: isKey, sending: true })

        return new Promise(resolve => {
          http({
            method: 'get',
            url: `/${serverModuleName}/api/${serverEntityName}/creditnote/${orderReturnId}`,
            responseType: 'blob'
          })
            .then(response => {
              console.log(response)
              resolve(response.data)
            })
            .catch(error => {
              console.log(error.response.data)
              resolve(error.response.data)
            })
            .finally(() => {
              commit('setLoading', { key: isKey, loading: false })
            })
        })
      }
    }
  })
}
